import React from "react";
import ScrollIcon from "./assets/scrollIcon.svg";
import { useNavigate } from "react-router-dom";
import { MdNextPlan } from "react-icons/md";
import { ImNext } from "react-icons/im";
import { FaForward ,FaHandPointRight} from "react-icons/fa6";
import { SlArrowRightCircle } from "react-icons/sl";
import { HiOutlineArrowRight } from "react-icons/hi";
interface BtnProps {
  nextRoute: string;
  titleProp ?: string; 
}
export const NextButton: React.FC<BtnProps> = ({ nextRoute, titleProp }) => {
  const navigate = useNavigate();
  const title = nextRoute.substring(1);
  return (
    <button
      title={
        titleProp? titleProp :
        title ? `${title.charAt(0).toUpperCase()}${title.substring(1)}` : "Home"
      }
      className={"fixed right-[5%] bottom-[5%] z-10 cursor-pointer text-primary-500 text-lg bg-dark-500 border-[2px] border-primary-500/20 transition-all duration-400 hover:border-primary-500  w-12 h-12 rounded-full flex items-center justify-center shadow-[0 0 0.4rem 0.2rem rgba(219, 144, 4, 0.4)]"}
      onClick={() => navigate(nextRoute)}
    >
      <HiOutlineArrowRight className=""/>
      {/* <img src={ScrollIcon} alt="Scroll" className="w-[50%] h-[50%] rotate-[-90deg]" /> */}
    </button>
  );
};
